import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities, SurfaceColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  pageTitle: {
    color: TextColors.light,
  },
  link: {
    color: TextColors.light,
  },
};

const lightTheme = {
  pageTitle: {
    color: TextColors.dark,
  },
  link: {
    color: TextColors.dark,
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.MuiBox-root': {
        color: TextColors.dark,
        alignItems: 'center',
        alignContent: 'center',

        [muiTheme.breakpoints.up('md')]: {
          alignItems: 'flex-end',
          alignContent: 'flex-end',
          margin: muiTheme.spacing(1, 0, 6),
        },
      },
    },
    title: {
      '&.MuiBox-root': {
        padding: muiTheme.spacing(0),

        [muiTheme.breakpoints.up('md')]: {
          marginRight: muiTheme.spacing(2),
          marginBottom: -3,
          minWidth: '354px',
          flexShrink: 1,
        },

        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: muiTheme.spacing(2),
          textAlign: 'left',
          width: '100%',
        },
      },
    },
    pageTitle: {
      marginRight: muiTheme.spacing(2),
      '&.dark-theme': darkTheme.pageTitle,
      '&.light-theme': lightTheme.pageTitle,
    },
    spacer: {
      '&.MuiBox-root': {
        flexGrow: 1,
      },
    },
    links: {
      padding: muiTheme.spacing(0),
      flexWrap: 'wrap',

      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(2),
        marginLeft: '-8px',
      },
    },
    link: {
      '&.MuiButtonBase-root': {
        whiteSpace: 'nowrap',
        minWidth: 0,

        '&.dark-theme': darkTheme.link,
        '&.light-theme': lightTheme.link,

        [muiTheme.breakpoints.down('sm')]: {
          color: SecondaryColors.dark,
          marginRight: muiTheme.spacing(1),

          '& .MuiButton-endIcon': {
            margingLeft: '-4px',
          },
        },

        [muiTheme.breakpoints.up('md')]: {
          marginRight: muiTheme.spacing(1.25),
        },
      },
    },
    filtersLinks: {
      '&.MuiBox-root': {
        position: 'relative',
        alignItems: 'baseline',
        alignContent: 'baseline',
        color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
        flexWrap: 'wrap',

        [muiTheme.breakpoints.down('sm')]: {
          flex: 0,
          width: '100%',
          marginLeft: muiTheme.spacing(-8),
        },

        [muiTheme.breakpoints.up('md')]: {
          marginBottom: '4px',
        },
      },
    },
    filters: {
      order: 1,
      display: 'flex',

      [muiTheme.breakpoints.down('sm')]: {
        order: 2,
        width: 'calc(100% + 64px)', // full width plus the lateral paddings
      },

      [muiTheme.breakpoints.up('md')]: {
        marginRight: muiTheme.spacing(1.75),
      },
    },
    filterButton: {
      color: TextColors.dark,
    },
    menuIcon: {
      color: SecondaryColors.dark,
    },
  }),
  { name: 'GenFilteredListTopBar' },
);

export default useStyles;
